import t from '@instructure/quiz-i18n/format-message';
import { DateTime } from 'luxon';
var minuteDuration = 60;
var hourDuration = 3600;
var formatHours = function formatHours(hours) {
  return t('{ hours, plural, one {# hour} other {# hours} }', {
    hours: hours
  });
};
var formatMinutes = function formatMinutes(minutes) {
  return t('{ minutes, plural, one {# minute} other {# minutes} }', {
    minutes: minutes
  });
};
var formatSeconds = function formatSeconds(seconds) {
  return t('{ seconds, plural, one {# second} other {# seconds} }', {
    seconds: seconds
  });
};
export var formatTimespan = function formatTimespan(startTime, endTime) {
  return formatTime(endTime - startTime, 1000);
};
export function formatTime(time) {
  var secondDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var totalSeconds = Math.floor(time / secondDuration);
  var parts = [];
  var hours = Math.floor(totalSeconds / hourDuration);
  if (hours !== 0) {
    parts.push(formatHours(hours));
  }
  var minutes = Math.floor(totalSeconds / minuteDuration) % minuteDuration;
  if (minutes !== 0) {
    parts.push(formatMinutes(minutes));
  }
  var seconds = totalSeconds % minuteDuration;
  if (seconds !== 0 || parts.length === 0) {
    parts.push(formatSeconds(seconds));
  }
  var separator = t({
    id: 'timespan_segment_separator',
    "default": ' ',
    description: 'The character(s) inserted between "5 minutes" and "30 seconds" in ' + 'a timespan string like "5 minutes 30 seconds"'
  });
  return parts.join(separator);
}
export function formatTimeToFullNumeric(seconds) {
  var hours = Math.floor(seconds / 3600);
  var minutes = Math.floor(seconds % 3600 / 60);
  var secs = seconds % 60;
  var hoursStr = hours < 10 ? '0' + hours : hours;
  var minutesStr = minutes < 10 ? '0' + minutes : minutes;
  var secsStr = secs < 10 ? '0' + secs : secs;
  return "".concat(hoursStr, ":").concat(minutesStr, ":").concat(secsStr);
}
export function displayDateAndTimeInTimezone(utcDateTime, userTimezone, locale) {
  return DateTime.fromISO(utcDateTime, {
    zone: userTimezone
  }).setLocale(locale).toLocaleString(DateTime.DATETIME_MED);
}